let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("if0l7"), load("8XFC9")]).then(() => parcelRequire('gnNGp'));